import { AlertCircle, CloudUpload, X } from "lucide-react";

import { Button, IconButton, ProgressBar } from "@/components/kit";

export function UploadRow({ u, onRetry, onDismiss }) {
  const bad = u.status === "failed" || u.status === "rejected";
  const pct = Math.round(u.progress * 100);
  return (
    <li className="fade-up flex min-h-[76px] items-center gap-3 rounded-xl border border-border bg-card px-3 py-2" data-testid={`upload-item-${u.key}`}>
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-secondary">
        {bad ? <AlertCircle className="h-6 w-6 text-destructive" aria-hidden /> : <CloudUpload className="h-6 w-6 text-primary" aria-hidden />}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <p className="truncate text-sm font-medium" data-testid={`upload-item-name-${u.key}`}>{u.file.name}</p>
        {bad ? (
          <p className="text-[13px] font-medium text-destructive" role="alert" data-testid={`upload-item-error-${u.key}`}>{u.error}</p>
        ) : (
          <ProgressBar value={pct} data-testid={`upload-item-progress-${u.key}`} />
        )}
      </div>
      {u.status === "failed" ? <Button title="Retry" compact variant="secondary" onClick={onRetry} data-testid={`upload-item-retry-${u.key}`} /> : null}
      {bad ? <IconButton icon={X} label="Dismiss" onClick={onDismiss} data-testid={`upload-item-dismiss-${u.key}`} /> : null}
      {!bad ? <span className="w-10 text-right text-[13px] tabular-nums text-muted-foreground" data-testid={`upload-item-percent-${u.key}`}>{pct}%</span> : null}
    </li>
  );
}
